module.exports = __webpack_public_path__ + "static/img/banner-plantas.28afe01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nuestra-empresa/banner-plantas.jpg
// module id = 2akJ
// module chunks = 0